import SearchEngineAdapter from 'Services/Adapters/SearchEngineBeta/SearchEngineAdapter';
import { v4 as uuidv4 } from 'uuid';

export default class CompanyAdapter extends SearchEngineAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'company';
    }

    constructor(data = [], query = '') {
        super(data, query);
        this.key = CompanyAdapter._key;
    }

    getStructure() {
        return {
            key: this.key,
            label: window.i18n.__('Société'),
            count: 0,
            items: [],
            filters: ['company'],
        };
    }

    formatItem(item) {
        return {
            id: item.object.id,
            name: this.checkFieldForQuery(item.name),
            address: this.checkFieldForQuery(this.formatAddress(item.invoicing_address)),
            type: item.object.sub_type,
            link: `/thirds/${item.object.sub_type}/${item.object.id}`,
            component: 'search-result-third',
            corpid: item.corp_id ? item.corp_id.toString() : null,
            uuid: uuidv4(),
            highlightedExtraFields: [
                {
                    label: window.i18n.__('Réf. :'),
                    value: this.checkFieldForQuery(item.reference, true),
                },
                {
                    label: window.i18n.__('Tél. :'),
                    value: this.checkFieldForQuery(item.phone_number, true),
                },
                {
                    label: window.i18n.__('Port. :'),
                    value: this.checkFieldForQuery(item.mobile_number, true),
                },
                {
                    label: window.i18n.__('Fax :'),
                    value: this.checkFieldForQuery(item.fax_number, true),
                },
                {
                    label: window.i18n.__('Email :'),
                    value: this.checkFieldForQuery(item.email, true),
                },
                {
                    label: window.i18n.__('Adr. de livraison :'),
                    value: this.checkFieldForQuery(this.formatAddress(item.delivery_address), true),
                },
            ],
        };
    }
}
